// Anchor
function anchor(ev, href) {
    ev.preventDefault();
    
    var anchor = href;
    if(!anchor.includes("popup")){
      $('html, body').animate({
        scrollTop: $(anchor).offset().top
      }, 500);
    } else {
      //console.log($('body').data('id'));
      if(anchor.includes("popup-harp-mini")) $('#popup-mini-modal').addClass('is-active');
      else  $('#popup-vault-modal').addClass('is-active');
    }
};

/*$('.c-popup-product-modal_close').on('click', function (){
	$(this).parent('.c-popup-product-modal').removeClass('is-active');
});*/

// Zoomed gallery
function zoomed(ev, elem) {
    ev.preventDefault();
  console.log($(elem).parent());
    $(elem).parent().children('.box-zoom').slideToggle();
    $(elem).parent().children('.box-zoom').addClass('zoomed');
};

function close_zoomed(ev, elem) {
    ev.preventDefault();
    $(elem).parent('.box-zoom').slideToggle();
    $(elem).parent('.box-zoom').removeClass('zoomed');
};


/*
$('#gallery-image-section .bg-img .c-media').on('click',function(ev){
  console.log('hello');
    ev.preventDefault();
    $(this).parent('.bg-img').children('.box-zoom').slideToggle();
    $(this).parent('.bg-img').children('.box-zoom').addClass('zoomed');
  });

  $('.c-gallery-modal_close').on('click',function(ev){
    ev.preventDefault();
    $(this).parent('.box-zoom').slideToggle();
    $(this).parent('.box-zoom').removeClass('zoomed');
  });*/

function isInViewport(t) {
    if ($(t).length) {
        var i = $(t).offset().top,
            e = i + $(t).outerHeight(),
            n = $(window).scrollTop(),
            s = n + ($(window).height() / 1.75);
        return e > n && i < s;
    }
    return !1;
}

function loadMore(elem) {
    var parent = $(elem).parent();
    if(parent.hasClass('content')) parent = parent.parent();
    parent.addClass('appear');
    parent.children('.filter-over-gradiant-black').fadeOut(500);
    $(elem).fadeOut();
}

$(document).ready(function () {


        console.log('jQuery Ready');

        $('a[href="#see-menu"]').on('click',function(ev){
          ev.preventDefault();
          $('html').removeClass('is-scrolling-down');
        });

    $('#gallery-image-section .box-zoom').each(function(){
      $(this).slideUp();
      $(this).removeClass('zoomed');
    });


        if($('html').attr('data-template') == 'page.waiting_redirect') {

          //$('html').on('change', function() {
            var redirect_url = 'https://santor.surveysparrow.com/s/V2-Pre-qualification-Form---Pipedrive---EN/tt-mCmvI'; 
            if($('html').attr('lang') == 'fr') {
              redirect_url = 'https://santor.surveysparrow.com/s/V2-Pre-qualification-Form---Pipedrive---FR/tt-tMSkK';
            } else if($('html').attr('lang') == 'es') {
              redirect_url = 'https://santor.surveysparrow.com/s/V2-Pre-qualification-Form---Pipedrive---ES/tt-yvuO8';
            } else if($('html').attr('lang') == 'pt-BR') {
              redirect_url = 'https://santor.surveysparrow.com/s/formulario-de-pre-qualificacao/tt-19jha';
            }

            window.addEventListener("load", function() {
              setTimeout(function() { 
                  window.location.replace(redirect_url);
              }, 5000);
            });
          
        }

        /*if($('a[data-language-code="pt-BR"]').length) {
          $('a[data-language-code="pt-BR"]').children('.ly-inner-text').html('PT');
        } else {
          setTimeout(function(){
            $('a[data-language-code="pt-BR"]').children('.ly-inner-text').html('PT');
          }, 1000);
        }*/
        
        
        /*if ($(location).attr("pathname").indexOf("/pages/thanks-booking") >= 0) {
          $('a').on('click', function(){
            event.preventDefault()
            var anchor_a = $(this).attr('href').replace($(location).attr("pathname"), '');
            console.log(anchor_a);
            if(anchor_a.includes("#")) {
              $('html, body').animate({
                scrollTop: $(anchor_a).offset().top
              }, 500);
            }
          });
        }*/
  
        /*$('.newletter').on('click',function(){
            var id_btn = $(this).attr('id');
            alert(id_btn);
            window._klOnsite = window._klOnsite || []; 
    		window._klOnsite.push(['openForm', id_btn]);
        });

        $('button[class*="popup-klaviyo-"]').on('click',function(){
            var id_btn = $.grep(this.className.split(" "), function(v, i){
                 return v.indexOf('popup-klaviyo-') === 0;
             }).join().slice(-6);
          
            window._klOnsite = window._klOnsite || []; 
    		window._klOnsite.push(['openForm', id_btn]);
        });*/
  
        var t = $(window).scrollTop();
  
        // Scrolling video set height
        if ($('#scrolling-video').length) {
          var half_h_ele = $('#scrolling-video').height()/2;
          var center_screen = ($('#scrolling-video').offset().top + half_h_ele) - 750;
          if(center_screen <= t && !$('#scrolling-video').find('.video-container').hasClass('in-view')) $('#scrolling-video').find('.video-container').addClass('in-view');
        }

        if ($('#newspapers').length) {
          var newspapers = $('#newspapers').find('.newspapers-container').find('img');
          
          if ( isInViewport(newspapers) ) {
            newspapers.addClass('in-view');
          }
        }
  
        if($('.c-highlight_accordeon').length && $(window).width() < 859) $('.c-highlight_accordeon').css('display', 'none');
      
        $(".display_more_testimonials").on("click", function () {
            $(this)
                .parent(".col-section")
                .children(".col-lg-4:hidden")
                .each(function () {
                    $(this).fadeIn();
                }),
                $(this).hide();
        });
        
        $(window).on("resize scroll", function () {
            var t = $(window).scrollTop();

            $('#scrolling-video').each(function(){
              if ( isInViewport(this) ) {
                var half_h_ele = $(this).height()/2;
                var center_screen = ($(this).offset().top + half_h_ele) - 750;
                if($(this).hasClass('embed-video')) center_screen = ($(this).offset().top + half_h_ele) - 500;
                var video_container = $(this).find('.video-container');
                var btn = $(this).find('.c-button');
                $(this).find('video')[0].play();
                
                if(center_screen <= t && !video_container.hasClass("in-view")) {
                  video_container.addClass('in-view');
                  if(btn) btn.addClass('in-view');
                } 
                else if(center_screen >= t && video_container.hasClass("in-view")) {
                  video_container.removeClass('in-view');
                  if(btn) btn.removeClass('in-view');
                } 
              } else {
                $(this).find('video')[0].pause();
              }
            });

            $('#newspapers').each(function(){
              const newspapers = $('#newspapers').find('.newspapers-container').find('img');
              
              if ( isInViewport(newspapers)) {
                if(!newspapers.hasClass("in-view")) newspapers.addClass('in-view');
              } else {
                if(newspapers.hasClass("in-view")) newspapers.removeClass('in-view');
              }
            });
          
              $(".nb_increments").each(function () {
                  if (isInViewport(this) && !$(this).hasClass("done")) {
                      var t = $(this),
                          i = t.attr("data-count");
                      $({ countNum: t.text() }).animate(
                          { countNum: i },
                          {
                              duration: 1500,
                              easing: "swing",
                              step: function () {
                                  var i = Math.floor(this.countNum).toString();
                                  if (Number(i) > 999) for (; /(\d+)(\d{3})/.test(i); ) i = i.replace(/(\d+)(\d{3})/, "$1 $2");
                                  else t.text(Math.floor(this.countYear));
                                  t.text(i), $(this).hasClass("done") || t.addClass("done");
                              },
                              complete: function () {
                                  var i = Math.floor(this.countNum).toString();
                                  if (Number(i) > 999) for (; /(\d+)(\d{3})/.test(i); ) i = i.replace(/(\d+)(\d{3})/, "$1 $2");
                                  t.text(i);
                              },
                          }
                      );
                  }
              });
                
                $(".parallax").each(function (i, e) {
                    if (isInViewport(this)) {
                        var n = $(this).position().top,
                            s = $(this).outerWidth(),
                            o = $(this).css("margin-top");
                        o.includes("px") && (o = o.slice(0, -2));
                        var a = $(window).outerWidth(),
                            l = (t - (n - parseFloat(o))) / (a / (s / 3.5));
                        $(this)
                            .find("img")
                            .first()
                            .css("top", "" + l + "px");
                    }
                });
          
                $("#calendly-embed").each(function () {
                    if (isInViewport(this) && !$(this).hasClass("loaded")) {
                        $(this).addClass("loaded");
                        var t = document.getElementById("calendly-embed"),
                            i = t.getAttribute("data-url");
                        (t.innerHTML = ""), Calendly.initInlineWidget({ url: i, parentElement: t });
                    }
                });
          
                $(".c-highlight_keys_item_col").on("click", function () {
                    var t = $(this).parent(".c-highlight_keys_item");
                    t.hasClass("open") ||
                        ($(".c-highlight_keys_item").each(function () {
                            $(this) !== t && ($(this).removeClass("open"), $(this).children(".c-highlight_accordeon").slideUp(500));
                        }),
                        $(t).toggleClass("open"),
                        $(t).children(".c-highlight_accordeon").slideDown(500));
                });

                if($('.carousel-testimonials').length && !$('.carousel-testimonials').hasClass("loaded")) {
                  //console.log('.carousel-testimonials');
                  if (!$('.carousel-testimonials').hasClass("loaded")) {

                    $('.carousel-testimonials').slick({
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      autoplay: true,
                      autoplaySpeed: 5000,
                      speed: 500,
                      arrows: true,
                      infinite: true,
                      adaptiveHeight: true,  
                    });

                    $('.carousel-testimonials').addClass("loaded"); //ge is-inview -lazy-loaded
                    $('.carousel-testimonials').find('.o-lazy_image').each(function () {
                      if(!$('.carousel-testimonials').hasClass('.-lazy-loaded')){
                        var img_src = $('.carousel-testimonials').attr('data-src');
                        $('.carousel-testimonials').attr('src', img_src);
                        $('.carousel-testimonials').addClass('is-inview -lazy-loaded');
                      }
                    });
                  }
                }
             /*if($('.carousel-image').length && !$('.carousel-image').hasClass("loaded")) {
                  if (!$('.carousel-image').hasClass("loaded")) {
                    //console.log('.carousel-image');
                    $('.carousel-image').slick({
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      autoplay: true,
                      autoplaySpeed: 5000,
                      speed: 500,
                      arrows: true,
                      infinite: true,
                      responsive: [
                        {
                          breakpoint: 600,
                          settings: {
                            slidesToShow: 1,
                          }
                        },
                        {
                          breakpoint: 991,
                          settings: {
                            slidesToShow: 2
                          }
                        }
                      ],
                    });
                    $('.carousel-image').addClass("loaded"); //ge is-inview -lazy-loaded
                    $('.carousel-image').find('.o-lazy_image').each(function () {
                      if(!$('.carousel-image').hasClass('.-lazy-loaded')){
                        var img_src = $('.carousel-image').attr('data-src');
                        $('.carousel-image').attr('src', img_src);
                        $('.carousel-image').addClass('is-inview -lazy-loaded');
                      }
                    });
                  }
                }*/

                
        }),
            $(".parallax").each(function (i, e) {
                if (isInViewport(this)) {
                    var n = $(this).position().top,
                        s = $(this).outerWidth(),
                        o = $(this).css("margin-top");
                    o.includes("px") && (o = o.slice(0, -2));
                    var a = $(window).outerWidth(),
                        l = (t - (n - parseFloat(o))) / (a / (s / 3.5));
                    $(this)
                        .find("img")
                        .first()
                        .css("top", "" + l + "px");
                }
            }),
            $("#calendly-embed").each(function () {
                if (isInViewport(this) && !$(this).hasClass("loaded")) {
                    $(this).addClass("loaded");
                    var t = document.getElementById("calendly-embed"),
                        i = t.getAttribute("data-url");
                    (t.innerHTML = ""), Calendly.initInlineWidget({ url: i, parentElement: t });
                }
            });

            
    });
